// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-0 {
  padding: 0 !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pr-1 {
  padding-right: 0.25rem !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pr-2 {
  padding-right: 0.5rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pl-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pr-4 {
  padding-right: 1.5rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pr-5 {
  padding-right: 3rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pl-5 {
  padding-left: 3rem !important;
}

.px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.px-4 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.px-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/padding.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACI,gCAAA;EACA,iCAAA;AACJ;;AACA;EACI,+BAAA;EACA,gCAAA;AAEJ;;AAAA;EACI,6BAAA;EACA,8BAAA;AAGJ;;AADA;EACI,+BAAA;EACA,gCAAA;AAIJ;;AAFA;EACI,6BAAA;EACA,8BAAA;AAKJ;;AAHA;EACI,+BAAA;EACA,kCAAA;AAMJ;;AAJA;EACI,8BAAA;EACA,iCAAA;AAOJ;;AALA;EACI,4BAAA;EACA,+BAAA;AAQJ;;AANA;EACI,8BAAA;EACA,iCAAA;AASJ;;AAPA;EACI,4BAAA;EACA,+BAAA;AAUJ","sourcesContent":[".p-0 {\n  padding: 0 !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n.px-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n}\n.px-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n}\n.px-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n}\n.px-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n}\n.px-5 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n}\n.py-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.py-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.py-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.py-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.py-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
